import { Directive, HostListener } from '@angular/core';

@Directive({ selector: '[restrictNumbers]' })
export class RestrictNumbersDirective {
  private readonly pattern = /^[0-9]*$/;

  @HostListener('keypress', ['$event'])
  onKeyPress(e: KeyboardEvent) {
    if (!/[0-9]/.test(e.key)) e.preventDefault();
  }

  @HostListener('paste', ['$event'])
  onPaste(e: ClipboardEvent) {
    const pasted = e.clipboardData?.getData('text') ?? '';
    if (!this.pattern.test(pasted)) e.preventDefault();
  }

  @HostListener('input', ['$event'])
  onInput(e: Event) {
    const el = e.target as HTMLInputElement;
    if (!this.pattern.test(el.value)) {
      el.value = el.value.replace(/[^0-9]/g, ''); // strip non-digits
    }
  }
}

